import naja from 'naja';

class Ares
{
    constructor()
    {
        this.errors = [];
        this.selectedSubject = null;
        this.addressData = null;
        this.subjects = [];
        this.initElements();
        this.saveButton.on('click', () => this.save())
    }
    addError(message)
    {
        this.errors.push(message);
        this.showErrors();
    }
    initElements()
    {
        this.results = $('#aresResults');
        this.saveButton = $('#aresBtnSave');
        this.aresName = $('#aresName');
        this.aresIc = $('#aresIc');
        this.aresDic = $('#aresDic');
        this.aresTaxpayer = $('#aresTaxpayer');
        this.aresMessage = $('#aresMessage');
        this.aresLoading = $('#aresLoading');
        this.aresData = $('#aresData');
        this.aresSubjectDetail = $('#aresSubjectDetail');
        this.aresType = $('#frm-tabs-tabContent-informace-tabControl-formContact-contact-typeId');
        // Skrytá pole hlavního formuláře kontaktu, kterými se adresa přenáší na server
        this.aresStreet = $('#aresStreet');
        this.aresTown = $('#aresTown');
        this.aresPostal = $('#aresPostal');
        this.aresLand = $('#aresLand');
        this.aresAddressBox = $('#aresAddressBox');
        this.aresApplyAddress = $('#aresApplyAddress');
        this.aresBillingPreview = $('#aresBillingPreview');
    }
    isOpen()
    {
        return this.results.length > 0 && this.saveButton.length > 0;
    }
    hasRequiredElements()
    {
        let requiredElements = [
            this.aresIc, this.aresName, this.aresMessage,
            this.aresLoading, this.aresData, this.aresSubjectDetail
        ];
        return requiredElements.every(element => element.length > 0);
    }
    validateICO(ico) {
        // IČO musí být řetězec nebo číslo a mít přesně 8 číslic
        if (typeof ico !== 'string' && typeof ico !== 'number') {
            return false;
        }

        // Převést na řetězec a odstranit případné bílé znaky
        ico = ico.toString().trim();

        if (ico.length !== 8 || !/^\d+$/.test(ico)) {
            return false;
        }

        // Výpočet kontrolního součtu podle algoritmu
        const weights = [8, 7, 6, 5, 4, 3, 2];
        let sum = 0;

        for (let i = 0; i < 7; i++) {
            sum += parseInt(ico[i]) * weights[i];
        }

        // Výpočet kontrolní číslice
        let mod = sum % 11;
        let checkDigit = mod === 0 ? 1 : 11 - mod;
        if (checkDigit === 10) checkDigit = 0;

        // Porovnat s poslední číslicí IČO
        return checkDigit === parseInt(ico[7]);
    }

    loadData()
    {
        let ic = (this.aresIc.val()); // nedělat Number(), aby nezmizely počáteční nuly
        let name = this.aresName.val();
        let data = { obchodniJmeno: name};
        let hasError = false;

        if (!this.aresIc.val() && name.length <= 0) {
            this.addError("Není vyplněno ani jméno ani IČ, nelze hledat v registru.");
        }

        if (this.aresIc.val() && !this.validateICO(ic)) {
            this.addError("IČ nemá správný formát.");
        }

        if (this.aresIc.val() && this.validateICO(ic)) {
            data = { ico: [ic] };
        }

        this.showSection(this.aresLoading);
        this.selectedSubject = null;
        if (!hasError) {
            this.postRequest(data);
        }
    }
    postRequest(data) {
        $.ajax({
            url: 'https://ares.gov.cz/ekonomicke-subjekty-v-be/rest/ekonomicke-subjekty/vyhledat',
            type: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data),
            success: this.showResults.bind(this),
            error: this.handleError.bind(this)
        });
    }

    showResults(data) {
        if (!data.hasOwnProperty('ekonomickeSubjekty'))
        {
            return this.addError("Neplatná odpověd ze serveru ARES");
        }

        this.subjects = data.ekonomickeSubjekty;
        this.reloadSubjects();
    }

    addSubject(subject)
    {
        this.results.append(`<option value="${subject.ico}">${subject.obchodniJmeno}</option>`);
    }

    reloadSubjects() {
        this.results.empty();
        this.subjects.forEach(subject => this.addSubject(subject));
        this.results.on('change', (e) => {
                this.selectedSubject = this.subjects.find(subject => subject.ico == e.target.value);
                this.showSelectedSubject()
        })
        this.showSection(this.aresData);
        this.results.prop('selectedIndex', 0).change();
    }

    showSelectedSubject() {
        this.addressData = null;
        this.aresAddressBox.hide();

        if (this.selectedSubject == null) {
            return false;
        }

        this.aresSubjectDetail.empty();
        if (this.selectedSubject.hasOwnProperty('obchodniJmeno')) {
            this.addDetailInfo('Jméno: ', this.selectedSubject.obchodniJmeno);
        }

        if (this.selectedSubject.hasOwnProperty('ico')) {
            this.addDetailInfo('IČ: ', this.selectedSubject.ico);
        }

        if (this.selectedSubject.hasOwnProperty('dic'))
        {
            this.addDetailInfo('DIČ: ', this.selectedSubject.dic);
        }

        if (this.selectedSubject.hasOwnProperty('sidlo')) {
            this.addDetailInfo('Adresa:', this.selectedSubject.sidlo.textovaAdresa);

            const sidlo = this.selectedSubject.sidlo;

            // Extrakce ulice a čísla domu (pokud není nazevCastiObce stejný jako nazevObce, přidáme ho do ulice)
            // Cislo domu a cislo orientacni
            let streetNumber = sidlo.cisloDomovni ? sidlo.cisloDomovni.toString() : '';
            if (sidlo.cisloOrientacni) {
                streetNumber += '/' + sidlo.cisloOrientacni.toString();
            }

            let street;
            if (sidlo.nazevUlice) {
                street = (sidlo.nazevUlice + ' ' + streetNumber).trim();
                if (sidlo.nazevCastiObce && sidlo.nazevCastiObce !== sidlo.nazevObce) {
                    street += ', ' + sidlo.nazevCastiObce;
                }
            } else {
                street = this.parseStreetFromTextovaAdresa(sidlo.textovaAdresa, streetNumber);
            }

            // Město/obec
            const town = sidlo.nazevObce || '';

            // PSČ - upravíme formát na "XXX XX"
            const postal = sidlo.psc ? sidlo.psc.toString().replace(/^(\d{3})(\d{2})$/, '$1 $2') : '';

            // Země (kodStatu převedeme na plný název)
            const land = sidlo.kodStatu === 'CZ' ? 'Czech Republic' : (sidlo.nazevStatu || '');

            // Adresa se drží v paměti a do formuláře se zapíše až potvrzením tlačítka Vybrat
            this.addressData = {
                street: street,
                town: town,
                postal: postal,
                land: land
            };

            this.aresAddressBox.show();
        }

    }

    formatAddress(address) {
        return [address.street, (address.postal + ' ' + address.town).trim(), address.land]
            .filter(part => part && part.length > 0)
            .join(', ');
    }

    // Zapíše adresu do skrytých polí formuláře kontaktu. Prázdné hodnoty = "adresu neměnit",
    // proto se při nepotvrzeném přepisu pole explicitně vyprazdňují.
    applyAddress() {
        if (this.aresStreet.length === 0) {
            return;
        }

        const apply = this.addressData !== null && this.addressData !== undefined
            && (this.aresApplyAddress.length === 0 || this.aresApplyAddress.is(':checked'));
        const address = apply ? this.addressData : { street: '', town: '', postal: '', land: '' };

        this.aresStreet.val(address.street);
        this.aresTown.val(address.town);
        this.aresPostal.val(address.postal);
        this.aresLand.val(address.land);

        if (this.aresBillingPreview.length === 0) {
            return;
        }

        if (apply) {
            this.aresBillingPreview
                .text('Po uložení bude nastaveno z ARES: ' + this.formatAddress(address))
                .show();
        } else {
            this.aresBillingPreview.hide().empty();
        }
    }

    parseStreetFromTextovaAdresa(textovaAdresa, streetNumber)
    {
        // Fallback, když ARES nevrátí nazevUlice — vyparsujeme ulici z textovaAdresa
        // Formáty: "Ulice 86, Dubice, 470 01 Česká Lípa" nebo "Ulice 13, 110 00 Praha 1"
        if (!textovaAdresa) {
            return streetNumber;
        }
        const parts = textovaAdresa.split(',').map(s => s.trim()).filter(Boolean);
        // Poslední část obsahuje PSČ + obec, tu odřízneme
        if (parts.length > 1 && /^\d{3}\s?\d{2}\b/.test(parts[parts.length - 1])) {
            parts.pop();
        }
        return parts.length > 0 ? parts.join(', ') : streetNumber;
    }

    addDetailInfo(label, value)
    {
        this.aresSubjectDetail.append(`<strong>${label}</strong><div>${value}</div><br>`);
    }

    handleError(xhr, status, error) {
        this.addError(error);
    }
    showErrors()
    {
        this.aresMessage.empty()
        this.errors.forEach(error => {
            if (error) {
                this.aresMessage.append(`<div class="alert alert-danger">${error}</div>`);
            }
        });
        this.showSection(this.aresMessage);
    }
    showSection(section)
    {
        this.aresMessage.hide();
        this.aresLoading.hide();
        this.aresData.hide();
        section.show();
    }
    save() {
        if (this.selectedSubject == null) {
            return false;
        }

        this.applyAddress();

        if (this.selectedSubject.hasOwnProperty('obchodniJmeno')) {
            this.aresName.val(this.selectedSubject.obchodniJmeno).trigger('change');
        }

        if (this.selectedSubject.hasOwnProperty('ico')) {
            this.aresIc.val(this.selectedSubject.ico).trigger('change');
        }

        if (this.selectedSubject.hasOwnProperty('dic'))
        {
            this.aresDic.val(this.selectedSubject.dic).trigger('change');
            this.aresTaxpayer.prop('checked', this.isVatPayer(this.selectedSubject)).trigger('change');
        }

        if (this.selectedSubject.hasOwnProperty('pravniForma')) {
            const pravniForma = Number(this.selectedSubject.pravniForma);
            const osvcCodes = [100, 101, 102, 104, 105, 106, 107, 108];

            const isOsvc = osvcCodes.indexOf(pravniForma) > -1;
            this.aresType.val(isOsvc ? 'osvc' : 'firma');
            this.aresType.trigger('change');
        }
    }

    isVatPayer(data) {
        const dic = data?.dic;
        const stavDph = data?.seznamRegistraci?.stavZdrojeDph;

        return !!dic && stavDph === 'AKTIVNI';
    }

}

const ARES_ADDRESS_INPUTS = ['aresStreet', 'aresTown', 'aresPostal', 'aresLand'];

function clearAresAddressFields()
{
    ARES_ADDRESS_INPUTS.forEach(id => {
        const input = document.getElementById(id);
        if (input) {
            input.value = '';
        }
    });

    const preview = document.getElementById('aresBillingPreview');
    if (preview) {
        preview.style.display = 'none';
        preview.textContent = '';
    }
}

// Skrytá pole s adresou z ARES jsou jednorázová. Formulář se po AJAX uložení nepřekresluje,
// takže je musíme vyprázdnit i v DOM - jinak by při dalším uložení znovu přepsala fakturační
// adresu, kterou uživatel mezitím ručně upravil (tiket 852).
//
// Vyprázdnit je ale smíme teprve tehdy, když server potvrdí, že adresu opravdu uložil
// (payload.aresAddressApplied). Dřív se mazala po každém requestu z formuláře - když
// uložení spadlo na validaci (chybí kategorie, duplicitní IČO), adresa se tiše ztratila
// a uživatel ji musel načíst z ARES znovu.
naja.addEventListener('success', (event) => {
    const payload = event.detail.payload;

    if (payload && payload.aresAddressApplied) {
        clearAresAddressFields();
    }
});

document.addEventListener('modalDialogOpened', (e) => {
    let ares = new Ares();
    if (!ares.isOpen())
    {
        return false;
    }

    if (ares.hasRequiredElements())
    {
        ares.loadData();
    } else {
        ares.addError("Interní chyba aplikace");
    }
});
